type WidthImage = 0 | 200 | 400 | 600 | 800 | 1000 | 1200 | 2000

export function getMediaLink(
    url: string | null,
    width: WidthImage = 0
): string | null {
    if (!url) return null
    const config = useRuntimeConfig()
    const imagePrefix = config.public.image_prefix
    if (config.public.app_env === 'PRODUCTION') {
        return `${imagePrefix}${width ? '/' + width : ''}${url}`
    }

    return `${imagePrefix}${url}`
}
